export default __webpack_public_path__ + "static/media/francheville07.88bcfa90.jpg";